<template>
  <v-container fluid class="pa-0">
    <div class="rotativo-dropdown-menu">
      <v-toolbar v-if="false"
          color="white"
          flat
          elevation="0"
          class="toolbar-menu"
          height="80"
      >
        <!-- Título e Subtítulo do módulo -->
        <v-toolbar-title class="d-flex flex-column justify-center py-2">
          <div class="d-flex align-center">
            <div class="icon-wrapper">
              <v-icon color="#023449" size="26">mdi-abacus</v-icon>
            </div>
            <div class="ml-3">
              <span class="module-title">Gestão de Rotativos de Estoque</span>
              <p class="subtitle mb-0">Acompanhamento e análise de inventários diários</p>
            </div>
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Botões de Navegação -->
        <div class="d-flex align-center navigation-buttons">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :class="['nav-button', { 'active': isActiveRoute('dashboard') }]"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click="navegarPara('dashboard')"
              >
                <v-icon left size="20">mdi-view-dashboard</v-icon>
                <span class="d-none d-sm-inline">Dashboard</span>
              </v-btn>
            </template>
            <span>Visualizar dashboard de rotativos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :class="['nav-button', { 'active': isActiveRoute('listagem') }]"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click="navegarPara('listagem')"
              >
                <v-icon left size="20">mdi-format-list-bulleted</v-icon>
                <span class="d-none d-md-inline">Listagem</span>
              </v-btn>
            </template>
            <span>Listar todos os rotativos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :class="['nav-button', { 'active': isActiveRoute('analise') }]"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click="navegarPara('analise')"
              >
                <v-icon left size="20">mdi-chart-line</v-icon>
                <span class="d-none d-md-inline">Análise</span>
              </v-btn>
            </template>
            <span>Análise e relatórios</span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <!-- Área de conteúdo -->
      <div class="content-main pt-0 mt-2">
        <transition name="page-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import mixinFilial from "../../util/mixinFilial";

export default {
  mixins: [mixinFilial],
  data() {
    return {
      activeMenu: null,
      carregando: false,
    };
  },
  computed: {
    ...mapState(["backendUrl", "usuario"]),
  },
  methods: {
    navegarPara(rota) {
      console.log('Navegando para:', rota);
      this.$router.push({ name: rota });
    },
    isActiveRoute(routeName) {
      return this.$route.name === routeName;
    }
  }
};
</script>

<style scoped>
.rotativo-dropdown-menu {
  width: 100%;
}

.toolbar-menu {
  border-bottom: 2px solid #023449;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.08);
}

/* Wrapper do ícone */
.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Título do módulo */
.module-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #023449;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 0.813rem;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.2;
  font-weight: 400;
}

/* Área de conteúdo */
.content-main {
  min-height: calc(100vh - 80px);
}

/* Botões de navegação */
.navigation-buttons {
  gap: 4px;
}

.nav-button {
  height: 44px !important;
  padding: 0 20px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  color: #64748b !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  letter-spacing: 0 !important;
}

.nav-button:hover {
  background-color: rgba(2, 52, 73, 0.06) !important;
  color: #023449 !important;
}

.nav-button.active {
  background-color: #023449 !important;
  color: white !important;
  box-shadow: 0 2px 6px rgba(2, 52, 73, 0.15);
}

.nav-button.active:hover {
  background-color: #034560 !important;
  color: white !important;
}

.nav-button >>> .v-icon {
  transition: transform 0.2s ease;
}

.nav-button:hover >>> .v-icon {
  transform: translateY(-1px);
}

/* Transição de páginas */
.page-fade-enter-active, .page-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.page-fade-enter {
  opacity: 0;
  transform: translateY(8px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Responsividade */
@media (max-width: 960px) {
  .toolbar-menu {
    height: auto !important;
    min-height: 80px;
    padding: 12px 16px !important;
  }

  .v-toolbar__content {
    flex-wrap: wrap;
    gap: 16px;
  }

  .navigation-buttons {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }

  .module-title {
    font-size: 1.125rem;
  }
}

@media (max-width: 600px) {
  .toolbar-menu {
    min-height: 120px;
  }

  .module-title {
    font-size: 1rem;
  }

  .subtitle {
    font-size: 0.75rem;
  }

  .icon-wrapper {
    padding: 8px;
  }

  .icon-wrapper >>> .v-icon {
    font-size: 22px !important;
  }

  .nav-button {
    height: 40px !important;
    padding: 0 14px !important;
    font-size: 0.813rem !important;
  }

  .navigation-buttons {
    flex-wrap: wrap;
  }
}

/* Acessibilidade */
@media (prefers-reduced-motion: reduce) {
  .page-fade-enter-active,
  .page-fade-leave-active,
  .nav-button,
  .nav-button >>> .v-icon {
    transition: none !important;
  }
}
</style>